import { render, staticRenderFns } from "./EventDetailShow.vue?vue&type=template&id=70293d5c&scoped=true&"
import script from "./EventDetailShow.vue?vue&type=script&lang=js&"
export * from "./EventDetailShow.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailShow.vue?vue&type=style&index=0&id=70293d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70293d5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VSpacer})
